import React, { useState } from 'react';
import { ScrollView, StatusBar, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useTheme, Snackbar } from 'react-native-paper';
import FloatingActionButton from '../components/FloatingActionButton';
import RecordCompletedJobBottomSheet from '../components/RecordCompletedJobBottomSheet';
import RevenueSummaryCard from '../components/RevenueSummaryCard';
import PerformanceTrendCard from '../components/PerformanceTrendCard';
import JobList from '../components/JobList';
import DashboardHeader from '../components/DashboardHeader';

interface DashboardScreenProps {
  onNavigateToJobs?: () => void;
}

const DashboardScreen: React.FC<DashboardScreenProps> = ({ onNavigateToJobs }) => {
  const theme = useTheme();
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);

  const handleAddTransaction = () => setShowTransactionModal(true);
  const handleCloseModal = () => setShowTransactionModal(false);
  const handleSuccess = () => setShowSuccessSnackbar(true);

  return (
    <SafeAreaView
      style={[styles.container, { backgroundColor: theme.colors.background }]}
    >
      <StatusBar
        barStyle="dark-content"
        backgroundColor={theme.colors.background}
      />
      <DashboardHeader />
      <ScrollView
        style={styles.scrollView}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.summaryWrapper}>
          <RevenueSummaryCard />
        </View>
        <PerformanceTrendCard />
        <JobList
          limit={5}
          showHeader={true}
          embedded={true}
          onSeeAll={onNavigateToJobs}
        />
        <View style={styles.bottomSpacing} />
      </ScrollView>
      <FloatingActionButton onPress={handleAddTransaction} />
      <RecordCompletedJobBottomSheet
        visible={showTransactionModal}
        onClose={handleCloseModal}
        onSuccess={handleSuccess}
      />

      <Snackbar
        visible={showSuccessSnackbar}
        onDismiss={() => setShowSuccessSnackbar(false)}
        duration={3000}
        action={{
          label: 'OK',
          onPress: () => setShowSuccessSnackbar(false),
        }}
      >
        Job recorded successfully!
      </Snackbar>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1 },
  scrollView: { flex: 1 },
  summaryWrapper: { paddingTop: 8 },
  bottomSpacing: { height: 100 },
});

export default DashboardScreen;
